import { AxiosResponse } from 'axios';
import { eventAxiosInstance } from 'axiosInstance';
import {
  StatusType,
  EventContextState,
  ExhibitionType,
} from 'context/EventContext';

type LanguageType = 'kor' | 'eng';

export type GetEventListQueryParmas = {
  type?: EventContextState['type'];
  status?: StatusType;
  language?: LanguageType;
  keyword?: string; // search keyword
  page_size?: number;
  page_num?: number;
  start_date?: string;
  end_date?: string;
};

export type EventItemRes = {
  eid: string;
  status: StatusType;
  thumbnail_url: string;
  title: string;
  language: LanguageType;
  start_time: string;
  end_time: string;
  type: ExhibitionType;
  location: string;
  booth_location: string;
  event_link: string;
  tags: string | null;
  pdf_url: string;
  has_pdf: boolean;
  description: string;
};

export type GetEventListRes = {
  all_count: number;
  curr_count: number;
  page_size: number;
  page_num: number;
  start_date: string;
  end_date: string;
  type: ExhibitionType;
  status: StatusType;
  language: LanguageType;
  keyword: string;
  events: EventItemRes[];
};

export const getEventList = async (
  queryParams: GetEventListQueryParmas
): Promise<GetEventListRes> => {
  try {
    const { data }: AxiosResponse<GetEventListRes> =
      await eventAxiosInstance.get('/event', { params: queryParams });

    return data;
  } catch (e) {
    console.log(e);
  }
};
